<div class="session-time-out-container">
  <form #loginForm [action]="loginPageURL" method="POST">
    <input [value]="refreshURL" name="refreshURL" type="hidden" />
  </form>
  <div class="bg-dark action-bar d-block d-lg-none d-xl-none"></div>
  <div class="modal-header pl-0 pr-0 pt-0 pb-0">
    <h2
      class="modal-title mt-2 pb-4 d-none d-sm-block d-md-block d-lg-block d-xl-block"
    >
      {{ contentSessionTimeOut?.sessionTimeoutMessageTitle }}
    </h2>
    <h2
      class="modal-title mt-2 pb-4 d-block d-sm-none d-md-none d-lg-none d-xl-none"
    >
      {{ contentSessionTimeOut?.sessionTimeoutMessageTitle }}
    </h2>
    <!-- <span class="sr-only" id="modalTitle">{{contentSessionTimeOut?.sessionTimeoutMessageTitle}}</span> -->
  </div>
  <div class="modal-body pl-0 pr-0 pt-0 pb-0">
    <p class="mt-4 pt-3">
      {{ contentSessionTimeOut?.sessionTimeoutMessageDescription }}
    </p>
    <p class="text-center remaining-time">
      {{ remMins }} {{ remMins > 1 ? 'Mins' : 'Min' }} {{ remSecs }}
      {{ remSecs > 1 ? 'Secs' : 'Sec' }}
    </p>
    <div class="mb-5 pt-3 modal-body-text">
      {{ contentSessionTimeOut?.timeoutStayLogInText }}
    </div>
  </div>
  <div class="modal-footer pl-0 pr-0 pt-0 pb-0 border-top-0">
    <a
      (click)="logMeOut()"
      class="log-out-link btn-outline-secondary-cta text-uppercase text-center mr-3"
      href="javascript:void(0)"
      id="log-out-link"
      role="button"
    >
      {{ contentSessionTimeOut?.logOutText }}
      <span class="sr-only">{{ ' and start over' }}</span>
    </a>
    <a
      (click)="keepLoggedIn()"
      class="log-in-link btn-danger text-uppercase text-center float-right"
      href="javascript:void(0)"
      id="log-in-link"
      role="button"
    >
      {{ contentSessionTimeOut?.loggedInText }}
      <span class="sr-only">{{ ' and continue session' }}</span>
    </a>
  </div>
</div>
